/* 用户相关 */
const state = {
    userInfo: {
        name: "test"
    },
    activeUserProfile: null, //当前选中的用户
    base64Photo: null,
    token: null,
    signUpPhone: "", //保存用于注册的手机号，注册成功后重置
    openId: null, //微信用户ID
}

// const getters = {
//     isLogin: state => {
//         return state.token !== null && state.token !== "";
//     }
// }

const mutations = {
    SET_IDCARD(state, data) {
        state.userInfo = data;
    },
    SET_SIGN_UP_PHONE(state, phone) {
        state.signUpPhone = phone;
        console.log(state.signUpPhone);
    },
    SET_ACTIVE_USER(state, data) {
        console.log(data);
        state.activeUserProfile = data;
    },
    SET_OPENID(state, openid) {
        state.openId = openid;
    }
}

const actions = {
    setIdCard(store, data) {
        store.commit("SET_IDCARD", data);
        console.log("set idcard data");
    },
    setPhoto(store, data) {
        store.commit("SET_PHOTO", data);
    },
    clearIdCard(store) {
        store.commit("CLEAR_IDCARD")
    },
    register(store) {

    },
    //用户登录
    login(store) {
        store.commit();
    },
    signUpPhone(context, phone) {
        context.commit("SET_SIGN_UP_PHONE", phone);
    },
    signOut(store) {
        store.commit();
    },
    setActiveUserProfile({
        commit
    }, data) {
        commit("SET_ACTIVE_USER", data);
    },
    setOpenId(store, openId) {
        store.commit("SET_OPENID", openId);
    },
}


export default {
    namespaced: true,
    state,
    // getters,
    mutations,
    actions
}